<template>
  <el-dialog
    :model-value="visible"
    :title="lang('privacy.policy')"
    :close-on-click-modal="false"
    custom-class="privacy-dialog"
    :before-close="handleClose"
    :width="640"
  >
    <div class="privacy">
      <div class="privacy-item" @click="navTo('/agreements/user-agreement')">
        <div>
          <img src="@/assets/images/privacy/icon1.svg" width="16" alt="" />
          <span>{{ lang('privacy.agreement') }}</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="privacy-item" @click="navTo('/agreements/Privacy-Policy')">
        <div>
          <img src="@/assets/images/privacy/icon2.svg" width="16" alt="" />
          <span>{{ lang('privacy.policy') }}</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="privacy-item" @click="navTo('/agreements/convention')">
        <div>
          <img src="@/assets/images/privacy/icon3.svg" width="16" alt="" />
          <span>{{ lang('privacy.convention') }}</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>
      <div class="privacy-item" @click="navTo('/agreements/algorithm')">
        <div>
          <img src="@/assets/images/privacy/icon4.svg" width="16" alt="" />
          <span>{{ lang('privacy.algorithm') }}</span>
        </div>
        <i class="el-icon-arrow-right"></i>
      </div>

      <p class="tip">
        <a href="https://www.cac.gov.cn/2024-04/11/c_1714509267496697.htm" target="_blank">{{
          lang('privacy.algorithmNumber')
        }}</a>
      </p>
    </div>
  </el-dialog>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { $t as lang } from '@/Tool'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
})
const emit = defineEmits(['update:visible'])

const language = localStorage.getItem('lang') || navigator.language.substr(0, 2)

const handleClose = () => {
  emit('update:visible', false)
}

const navTo = (url) => {
  window.open(`${location.origin}/vshow-main` + url + '-' + language + '.html', '_blank')
}
</script>

<style lang="scss">
.privacy-dialog {
  border-radius: 12px !important;
  .el-dialog__body {
    padding: 10px 40px 20px;
  }
}
</style>

<style lang="scss" scoped>
.privacy {
  &-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    padding: 15px 0;
    border-bottom: 1px solid rgba(220, 223, 230, 0.4);
    &:last-child {
      border: none;
    }
    & > div {
      display: flex;
      align-items: center;
      gap: 10px;
      span {
        color: #33353b;
      }
    }
  }

  .tip {
    font-weight: 400;
    font-size: 10px;
    margin-top: 90px;
    text-align: center;
    a {
      color: #999 !important;
    }
  }
}
</style>
